module.exports = __webpack_public_path__ + "static/media/ticket.64b49a83.svg";